import React from 'react';
import { Box, CircularProgress, useTheme } from '@mui/material';

const LoadingScreen = () => {
  const theme = useTheme();
  
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh', 
        background: `linear-gradient(135deg, #121212 0%, #2c3e50 100%)`
      }}
    >
      <CircularProgress size={60} sx={{ color: 'white' }} />
    </Box>
  );
};

export default LoadingScreen;
